class FeaturePillsProduct extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll(".pill-btn");
    this.lists = this.querySelectorAll(".pill-features__list");
    this.images = this.querySelectorAll(".pill-img");

    this.gallerySelector = ".product-media__gallery--slider";

    // try to bind now + whenever the slider is recreated
    const bind = () => {
      this.gallery = document.querySelector(this.gallerySelector);
      this.slider = this.gallery?._keenSliderInstance || null;
    };
    bind();
    document.addEventListener("product:slider-ready", bind);

    this.buttons.forEach((btn) => {
      btn.addEventListener("click", () => this.onPillClick(btn));
    });

    // init to first pill (optional)
    if (this.buttons.length) this.onPillClick(this.buttons[0], true);
  }

  onPillClick(btn, isInit = false) {
    const id = btn.dataset.target;
    const label = btn.textContent.trim().toLowerCase();
    this.activate(id);
  }

  activate(id) {
    this.buttons.forEach((b) =>
      b.classList.toggle("active", b.dataset.target === id)
    );
    this.lists.forEach((l) =>
      l.classList.toggle("active", l.id === `pill-list-${id}`)
    );
    this.images.forEach((img) =>
      img.classList.toggle("active", img.id === `pill-image-${id}`)
    );
  }
}

if (!customElements.get("feature-pills-product")) {
  customElements.define("feature-pills-product", FeaturePillsProduct);
}
